import { ACCESS_TOKEN_KEY } from "../Services/api";
import { ADMIN_PERMISSION_KEY } from "./PermissionContext";

export const logout = (navigate: any) => {
  sessionStorage.clear();
  navigate("/login");
};

export const isLoggedIn = () => {
  return !!sessionStorage.getItem(ACCESS_TOKEN_KEY);
};

export const clearAdminPermission = () => {
  sessionStorage.removeItem(ADMIN_PERMISSION_KEY);
};
